<div class="variable">
  <dx-button [text]="show1 ? 'Clear Variable 1' : 'Set Variable 1'" (onClick)="show1=!show1;clear(1)"></dx-button>
  <app-range-variable-form *ngIf="show1" [errors]="errors" [id]="1" [variables]="variables" (valueChange)="valueChanged($event)"></app-range-variable-form>
</div>
